export default "__VITE_ASSET__9b84207d__"